import React from 'react';
import styled from 'styled-components/macro';
import H3 from './H3';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 70%;
`;

const ImgContainer = styled.div``;

const P = styled.div`
  line-height: 1.6;
  opacity: 0.7;
`;

const Slide = ({ img, number, title, children }) => {
  return (
    <Container>
      <Wrapper>
        <ImgContainer>
          <img src={img} alt="" />
        </ImgContainer>
        <div style={{ marginTop: 22, marginBottom: 12 }}>
          <H3 as="span" style={{ opacity: 0.7 }}>
            {number}.
          </H3>
          <H3 as="span" style={{ paddingLeft: 8 }}>
            {title}
          </H3>
        </div>
        <P>{children}</P>
      </Wrapper>
    </Container>
  );
};

export default Slide;
